const resources = {
    getTheseBeforeGone: 'Procurez-vous-les avant qu’ils ne partent'

};

export default function getResource(label) {
    return resources[label];
}
